type ColorGroup = {
  ["100"]: string;
  ["200"]: string;
  ["300"]: string;
  ["400"]: string;
  ["500"]: string;
  ["600"]: string;
  ["700"]: string;
  ["800"]: string;
  ["900"]: string;
};

type ColorVariants = "grey" | "red" | "green" | "blue";

type Colors = {
  [k in ColorVariants]: ColorGroup;
};

const colors: Colors = {
  grey: {
    100: "rgba(213, 218, 230, 0.16)",
    200: "rgba(0, 0, 0, 0.07)",
    300: "rgba(180, 180, 180, 1)",
    400: "rgba(26, 26, 26, 0.4)",
    500: "#8C94A3",
    600: "rgba(090, 090, 090, 1)",
    700: "rgba(060, 060, 060, 1)",
    800: "rgba(030, 030, 030, 1)",
    900: "#191919",
  },

  red: {
    100: "rgba(240, 0, 0, 1)",
    200: "#FFA99D",
    300: "rgba(180, 0, 0, 1)",
    400: "#E33D3B",
    500: "rgba(120, 0, 0, 1)",
    600: "rgba(090, 0, 0, 1)",
    700: "#AB2826",
    800: "rgba(030, 0, 0, 1)",
    900: "rgba(005, 0, 0, 1)",
  },

  green: {
    100: "rgba(0, 240, 0, 1)",
    200: "rgba(0, 210, 0, 1)",
    300: "rgba(0, 180, 0, 1)",
    400: "rgba(0, 150, 0, 1)",
    500: "rgba(0, 121, 0, 1)",
    600: "rgba(0, 090, 0, 1)",
    700: "rgba(0, 060, 0, 1)",
    800: "rgba(0, 030, 0, 1)",
    900: "rgba(0, 005, 0, 1)",
  },

  blue: {
    100: "rgba(0, 0, 240, 1)",
    200: "rgba(130, 207, 249, 1)",
    300: "rgba(0, 0, 180, 1)",
    400: "rgba(4, 115, 220, 1)",
    500: "rgba(0, 0, 120, 1)",
    600: "rgba(0, 0, 090, 1)",
    700: "rgba(0, 0, 060, 1)",
    800: "rgba(0, 0, 030, 1)",
    900: "rgba(0, 0, 005, 1)",
  },
};

export default colors;
